export default __webpack_public_path__ + "static/media/mode-49.0f98e859.svg";